/**
 * JoinARJoinWeekDemoView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait JoinARJoinWeekDemo
 */

import { useJoinARJoinWeekDemoLogic } from '@/hooks/traits/useJoinARJoinWeekDemoLogic';
import type { JoinARJoinWeekDemoConfig } from '@/hooks/traits/useJoinARJoinWeekDemoLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { JoinARDemoWeekStep } from '@app/shared';
import { JoinARDemoWeekTourView } from '@/components/traits/JoinARDemoWeekTourView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface JoinARJoinWeekDemoViewProps {
  config?: Partial<JoinARJoinWeekDemoConfig>;
}

export function JoinARJoinWeekDemoView({ config: propsConfig }: JoinARJoinWeekDemoViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useJoinARJoinWeekDemoLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['JoinARDemoWeekStep'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="JoinAR" trait="JoinARJoinWeekDemo">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="md"><JoinARDemoWeekTourView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default JoinARJoinWeekDemoView;
